export { default } from './ComplaintsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/complaints/services/ComplaintsService/index.js